import React from "react";
import styles from "./Button.module.scss";
import cn from "classnames";

interface ButtonProps {
    isLink?: boolean,
    isActive?: boolean,
    type?: "button" | "submit" | "reset",
    href?: string,
    disabled?: boolean,
    classButton?: string,
    className?: string,
    children: React.ReactNode,
    onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
}

const Button: React.FC<ButtonProps> = (
    {
        isLink = false,
        isActive = false,
        type = "button",
        href,
        disabled = false,
        classButton,
        className,
        children,
        onClick
    }) => {

    const buttonClass = cn(styles.button, classButton, className, {
        [styles.isActive]: isActive,
        [styles.disabled]: disabled,
        [styles.redButton]: classButton === "redButton",
        [styles.tabButton]: classButton === "tabButton",
    });

    return (
        <>
            {isLink ? (
                <a href={href} className={buttonClass} onClick={onClick}>
                    {children}
                </a>
            ) : (
                <button
                    type={type}
                    className={buttonClass}
                    disabled={disabled}
                    onClick={onClick}
                >
                    {children}
                </button>
            )}
        </>
    );
}

export default Button;
